// import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function CalculateCost({ openContactModal }) {

  const ftToMeter = (value) => value * 0.3048;
const meterToFt = (value) => value * 3.28084;
const SQM_TO_SQFT = 10.7639;
const SQFT_TO_SQM = 0.092903;


  const navigate = useNavigate();

const validateStep4 = () => {
  let newErrors = {};

  // Name: only letters and spaces
  if (!/^[A-Za-z ]+$/.test(formData.fullName.trim())) {
    newErrors.fullName = "Enter a valid name (letters only)";
  }

  // Email: gmail only
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
  newErrors.email = "Enter a valid email address";
}

  // Phone: exactly 10 digits
  if (!/^[0-9]{10}$/.test(formData.phone.trim())) {
    newErrors.phone = "Enter a valid 10-digit phone number";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});

  const [areaType, setAreaType] = useState("plot"); // plot / total

  const [formData, setFormData] = useState({
    length: "",
    width: "",
    totalArea: "",
    calculatedArea: "",
  unit: "Feet",
    architecture: "design",
    construction: "",

    liaisoning: false,
    authority: "",

    fullName: "",
    email: "",
    phone: "",
  });

const prevUnit = useRef("Feet"); 

  // Auto Calculate Area
useEffect(() => {

if(areaType !== "plot") return;

if(formData.length && formData.width){

let area = Number(formData.length) * Number(formData.width);

// agar unit feet hai to meter² me convert karo
if(formData.unit === "Feet"){
area = area * SQFT_TO_SQM;
}

setFormData(prev => ({
...prev,
calculatedArea: area.toFixed(2)
}))

}else{

setFormData(prev => ({
...prev,
calculatedArea:""
}))

}

},[formData.length,formData.width,areaType,formData.unit])

useEffect(() => {

if (!formData.length && !formData.width) {
  prevUnit.current = formData.unit;
  return;
}

if(prevUnit.current === formData.unit) return;

setFormData(prev => {

let length = Number(prev.length);
let width = Number(prev.width);

if(prevUnit.current === "Feet" && prev.unit === "Meters"){
length = ftToMeter(length);
width = ftToMeter(width);
}

if(prevUnit.current === "Meters" && prev.unit === "Feet"){
length = meterToFt(length);
width = meterToFt(width);
}

return{
...prev,
length: length ? length.toFixed(2) : "",
width: width ? width.toFixed(2) : ""
}

})

prevUnit.current = formData.unit;

},[formData.unit])

  const isStep1Valid = () => {
    if (areaType === "plot") {
      return formData.length && formData.width;
    }
    return formData.totalArea;
  };

  // const isStep2Valid = () => {
  //   const finalArea =
  //     areaType === "plot" ? formData.calculatedArea : formData.totalArea;

  //   return finalArea && Number(finalArea) > 0;
  // };

  const isStep3Valid = () => {
    if (!formData.architecture) return false;
    if (!formData.construction) return false;

    if (formData.liaisoning) {
      return formData.authority !== "";
    }
    return true;
  };

  const isStep4Valid = () => {
    return (
      formData.fullName.trim() !== "" &&
      formData.email.trim() !== "" &&
      formData.phone.trim() !== ""
    );
  };

  const handleNext = () => {
    // if (step === 1) {
    //   if (!isStep1Valid()) return;

    //   if (areaType === "plot") {
    //     const calculated = Number(formData.length) * Number(formData.width);
    //     setFormData((prev) => ({
    //       ...prev,
    //       calculatedArea: calculated.toString(),
    //     }));
    //   }

    //   setStep(2);
    //   return;
    // }

    if (step === 1) {
  if (!isStep1Valid()) return;

  // agar plot dimension use hua hai to area calculate karo
  if (areaType === "plot") {
    let area = Number(formData.length) * Number(formData.width);

    if (formData.unit === "Feet") {
      area = area * SQFT_TO_SQM;
    }

    setFormData((prev) => ({
      ...prev,
      calculatedArea: area.toFixed(2),
    }));
  }

  // direct services step par jao
  setStep(2);
  return;
}

if (step === 2) {
  if (!isStep3Valid()) return;
  setStep(3);
  return;
}

    // if (step === 2) {
    //   if (!isStep2Valid()) return;
    //   setStep(3);
    //   return;
    // }

    
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  

  //  PDF Generate Function
  const generatePDF = (finalArea) => {
    const doc = new jsPDF();

    // Header background
    doc.setFillColor(0, 51, 102);
    doc.rect(0, 0, 210, 30, "F");

    // Title
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(18);
    doc.text("Dwellora Homes", 14, 18);

    doc.setFontSize(11);
    doc.text("Detailed Estimate Report", 14, 26);

    // Reset text color
    doc.setTextColor(0, 0, 0);

    // Client Details Box
    doc.setFillColor(245, 245, 245);
    doc.rect(14, 40, 182, 35, "F");

    doc.setFontSize(12);
    doc.text("Client Details", 18, 50);

    doc.setFontSize(10);
    doc.text(`Full Name: ${formData.fullName}`, 18, 58);
    doc.text(`Email: ${formData.email}`, 18, 65);
    doc.text(`Phone: ${formData.phone}`, 120, 58);
    doc.text(`Date: ${new Date().toLocaleString()}`, 120, 65);

    // Property Details Box
    doc.setFillColor(255, 255, 255);
    doc.rect(14, 85, 182, 60);

    doc.setFontSize(12);
    doc.text("Property Details", 18, 95);

    doc.setFontSize(10);
    doc.text(`Area Type: ${areaType}`, 18, 105);
    // doc.text(`Length: ${formData.length || "-"} m`, 18, 113);
    // doc.text(`Width: ${formData.width || "-"} m`, 18, 121);

doc.text(`Length: ${formData.length || "-"} ${formData.unit}`, 18, 113);
doc.text(`Width: ${formData.width || "-"} ${formData.unit}`, 18, 121);

    doc.text(`Total Area: ${formData.totalArea || "-"} sq.m`, 18, 129);
    // doc.text(
    //   `Calculated Area: ${formData.calculatedArea || "-"} sq.m`,
    //   18,
    //   137
    // );

    doc.text(`Calculated Area: ${formData.calculatedArea || "-"} ${formData.unit === "Feet" ? "sq.ft" : "sq.m"}`, 18, 137);

    doc.setFontSize(11);
    doc.setTextColor(0, 51, 102);
    doc.text(`Final Area: ${finalArea} sq.m`, 130, 105);

    // Selected Services Box
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(245, 245, 245);
    doc.rect(14, 155, 182, 55, "F");

    doc.setFontSize(12);
    doc.text("Selected Services", 18, 165);

    doc.setFontSize(10);
    doc.text(`Architecture: ${formData.architecture}`, 18, 175);
    doc.text(`Construction: ${formData.construction}`, 18, 183);
    
    doc.text(`Liaisoning: ${formData.liaisoning ? "Yes" : "No"}`, 18, 191);
    doc.text(`Authority: ${formData.authority || "-"}`, 18, 199);

    // Footer Line
    doc.setDrawColor(0, 51, 102);
    doc.line(14, 225, 196, 225);

    // Footer Text
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(
      "Dwellora Homes | Pune | Contact: +91 9158-941-222 | www.dwellorahomes.com",
      14,
      235
    );

    // Save PDF
    doc.save("Dwellora_Estimate.pdf");
  };

  const sendWhatsApp = (finalArea) => {
  const phone = formData.phone;

  const message = `
🏡 Dwelloara Homes Estimate

👤 Name: ${formData.fullName}
📞 Mobile: ${formData.phone}
📧 Email: ${formData.email}

📐 Area: ${finalArea} sq.m

🛠 Services:
- Architecture: ${formData.architecture}
- Construction: ${formData.construction}
- Liaison: ${formData.liaisoning ? formData.authority : "No"}

Dwelloara Homes
📞 +91 9158941222
`;

  const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};

  //  Final Submit (Sheet + PDF + WhatsApp)
const handleSubmit = async () => {
  if (!validateStep4()) return;

  const finalArea =
    areaType === "plot"
      ? formData.calculatedArea
      : formData.totalArea;

  const payload = {
    ...formData,
    finalArea,
    areaType,
    architecture: "yes", 

  construction:
    formData.construction === "pmc"
      ? "interior"
      : formData.construction, 

  liaisoning: formData.architecture === "liaison" ? 1 : 0,

  };

  try {
    await axios.post(
      "https://dwellorahomes.com/estimate.php",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

generatePDF(finalArea);

Swal.fire({
  title: "Submitted!",
  html: "<b>Thank you! Your request has been submitted successfully.</b>",
  icon: "success",
  showConfirmButton: true,
  confirmButtonColor: "#4d2c5e",
  backdrop: `rgba(0,0,0,0.7)`,
});


// alert("Thank you! Your request has been submitted successfully.");

setTimeout(() => {
  navigate("/");
}, 1500);
    

  } catch (error) {
    console.log(error);
    alert("Backend not running or Sheet error!");
  }
};

  const finalArea =
    areaType === "plot" ? formData.calculatedArea : formData.totalArea;

    const displayArea =
formData.unit === "Feet"
? (Number(finalArea) * SQM_TO_SQFT).toFixed(2)
: finalArea;

  return (
  
      <div className="dw-estimate-wrapper">
        {/* LEFT SIDE */}
        <div className="dw-estimate-left">
          <h2>
            Get Your Home <br /> Estimate
          </h2>
          <p>Quick, accurate and transparent Pricing</p>

          <div className="dw-step-list">
            {/* STEP 1 */}
            <div className={`dw-step-item ${step >= 1 ? "active" : ""}`}>
              <div className="dw-step-icon">
                <span className="dw-step-circle">{step > 1 ? "✓" : "01"}</span>
                <span className={`dw-step-line ${step > 1 ? "filled" : ""}`} />
              </div>

              <div className="dw-step-text">
                <h6>Property Details</h6>
                {/* <p>Tell us about your plot dimension</p> */}
                  <p>Tell us about your plot or total area</p>
              </div>
            </div>

            {/* STEP 2 */}
            <div className={`dw-step-item ${step >= 2 ? "active" : ""}`}>
              <div className="dw-step-icon">
                <span className="dw-step-circle">{step > 2 ? "✓" : "02"}</span>
                <span className={`dw-step-line ${step > 2 ? "filled" : ""}`} />
              </div>

              <div className="dw-step-text">
                <h6>Select Services</h6>
                <p>Choose the services you need for your project.</p>
              </div>
            </div>

            {/* STEP 3 */}
            <div className={`dw-step-item ${step >= 3 ? "active" : ""}`}>
              <div className="dw-step-icon">
                <span className="dw-step-circle">{step > 3 ? "✓" : "03"}</span>
              </div>

              <div className="dw-step-text">
                <h6>Contact Information</h6>
                <p>
                  Provide your contact details so we can send you the estimate.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="dw-estimate-right">
          <div className="dw-estimate-card">
           {/* STEP 1 */}
{step === 1 && (
  <>
    <h4>Property Details</h4>
    <p className="dw-subtext">
      Let’s start with the basic details of your project.
    </p>

    {/* <p className="dw-label">
      How would you like to provide area information?
    </p> */}

<p className="dw-label">
      How would you like to enter your area details?
    </p>

    <div className="dw-toggle-btns">
      <button
        className={areaType === "plot" ? "active" : ""}
        onClick={() => setAreaType("plot")}
      >
        Plot Dimensions
      </button>

      <button
        className={areaType === "total" ? "active" : ""}
        onClick={() => setAreaType("total")}
      >
        Total Area
      </button>
    </div>

   {areaType === "plot" && (
  <>
    {/* UNIT SELECT */}
    <div className="dw-field dw-float">
      <select
        value={formData.unit}
        onChange={(e) =>
          setFormData({ ...formData, unit: e.target.value })
        }
        required
      >
        <option value="Feet">Feet</option>
        <option value="Meters">Meters</option>
      </select>
      <label>Select Unit</label>
    </div>

    {/* LENGTH */}
    <div className="dw-field dw-unit-field">
      <input
        type="number"
        placeholder=" "
        value={formData.length}
        onChange={(e) =>
          setFormData({ ...formData, length: e.target.value })
        }
      />
      <label>Length</label>
      <span className="dw-unit">
        {formData.unit === "Meters" ? "m" : "ft"}
      </span>
    </div>

    {/* WIDTH */}
    <div className="dw-field dw-unit-field">
      <input
        type="number"
        placeholder=" "
        value={formData.width}
        onChange={(e) =>
          setFormData({ ...formData, width: e.target.value })
        }
      />
      <label>Width</label>
      <span className="dw-unit">
        {formData.unit === "Meters" ? "m" : "ft"}
      </span>
    </div>
  </>
)}

    {areaType === "total" && (
      <div className="dw-field">
        <input
          type="number"
          placeholder=" "
          value={formData.totalArea}
          onChange={(e) =>
            setFormData({ ...formData, totalArea: e.target.value })
          }
        />
        <label>Total Area*</label>
      </div>
    )}

    <button
      className={`dw-next-btn ${!isStep1Valid() ? "disabled" : ""}`}
      disabled={!isStep1Valid()}
      onClick={handleNext}
    >
      Next <span className="dw-arrow">&#x203A;</span>
    </button>
  </>
)}

            {/* STEP 2 */}
            {/* {step === 2 && (
              <>
                <h4>Property Details</h4>
                <p className="dw-subtext">
                  Your total area is calculated below.
                </p>

                <p className="dw-label">
                  How would you like to provide area information?
                </p>

                <div className="dw-toggle-btns">
                  <button disabled>Plot Dimensions</button>
                  <button className="active" disabled>
                    Total Area
                  </button>
                </div>

                <label>Total Area (square meters)*</label>
              
                <input
type="text"
value={`${displayArea} ${formData.unit === "Feet" ? "sq.ft" : "sq.m"}`}
readOnly
/>

                <button className="dw-next-btn" onClick={handleNext}>
                  Next <span className="dw-arrow">&#x203A;</span>
                </button>
              </>
            )} */}

            {/* STEP 3 */}
            {step === 2 && (
              <>
                <h4 className="dw-step-title">Select Services</h4>
                <p className="dw-subtext">
                  Choose the services you need for your project.
                </p>

                {/* Architectural Consultancy */}
                {/* <div className="dw-radio-block">
                  <h6>Architectural Consultancy Service</h6>

                  <label className="dw-option">
                    <input
                      type="radio"
                      name="architecture"
                      checked={formData.architecture === "yes"}
                      onChange={() =>
                        setFormData({ ...formData, architecture: "yes" })
                      }
                    />
                    <span className="dw-custom-radio"></span>
                    <span className="dw-option-text">
                      Yes, include architectural consultancy
                    </span>
                  </label>

                  <label className="dw-option">
                    <input
                      type="radio"
                      name="architecture"
                      checked={formData.architecture === "no"}
                      onChange={() =>
                        setFormData({ ...formData, architecture: "no" })
                      }
                    />
                    <span className="dw-custom-radio"></span>
                    <span className="dw-option-text">No, skip this service</span>
                  </label>
                </div> */}

                {/* Construction Services */}
                {/* <div className="dw-radio-block">
                  <h6>Construction Services</h6>

                  <label className="dw-option">
                    <input
                      type="radio"
                      name="construction"
                      checked={formData.construction === "grey"}
                      onChange={() =>
                        setFormData({ ...formData, construction: "grey" })
                      }
                    />
                    <span className="dw-custom-radio"></span>
                    <span className="dw-option-text">Grey Structure Only</span>
                  </label>

                  <label className="dw-option">
                    <input
                      type="radio"
                      name="construction"
                      checked={formData.construction === "complete"}
                      onChange={() =>
                        setFormData({ ...formData, construction: "complete" })
                      }
                    />
                    <span className="dw-custom-radio"></span>
                    <span className="dw-option-text">
                      Complete Construction with Finishing
                    </span>
                  </label>

                  <label className="dw-option">
                    <input
                      type="radio"
                      name="construction"
                      checked={formData.construction === "interior"}
                      onChange={() =>
                        setFormData({ ...formData, construction: "interior" })
                      }
                    />
                    <span className="dw-custom-radio"></span>
                    <span className="dw-option-text">
                      Full Home Interior Package
                    </span>
                  </label>
                </div> */}

                {/* Additional Services */}
                {/* <div className="dw-radio-block">
                  <h6>Additional Services</h6>

                  <label className="dw-option">
                    <input
                      type="checkbox"
                      checked={formData.liaisoning}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          liaisoning: e.target.checked,
                          authority: "",
                        })
                      }
                    />
                    <span className="dw-custom-checkbox"></span>
                    <span className="dw-option-text">
                      Liaisoning Services (Corporation approvals)
                    </span>
                  </label>

                  {formData.liaisoning && (
                    <div className="dw-authority-box">
                      <label className="dw-option">
                        <input
                          type="radio"
                          name="authority"
                          value="PCMC"
                          checked={formData.authority === "PCMC"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              authority: e.target.value,
                            })
                          }
                        />
                        <span className="dw-custom-radio"></span>
                        <span className="dw-option-text">
                          PCMC ( Pimpri chinchwad municipal corporation approvals )
                        </span>
                      </label>

                      <label className="dw-option">
                        <input
                          type="radio"
                          name="authority"
                          value="PMC"
                          checked={formData.authority === "PMC"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              authority: e.target.value,
                            })
                          }
                        />
                        <span className="dw-custom-radio"></span>
                        <span className="dw-option-text">
                          PMC (Pune Municipal Corporation approvals )
                        </span>
                      </label>

                      <label className="dw-option">
                        <input
                          type="radio"
                          name="authority"
                          value="Municipal"
                          checked={formData.authority === "Municipal"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              authority: e.target.value,
                            })
                          }
                        />
                        <span className="dw-custom-radio"></span>
                        <span className="dw-option-text">
                          Municipal Corporation approvals
                        </span>
                      </label>

                      <label className="dw-option">
                        <input
                          type="radio"
                          name="authority"
                          value="PMRDA"
                          checked={formData.authority === "PMRDA"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              authority: e.target.value,
                            })
                          }
                        />
                        <span className="dw-custom-radio"></span>
                        <span className="dw-option-text">
                          PMRDA ( Pune Metropolitan Region development Authority approvals)
                        </span>
                      </label>
                    </div>
                  )}
                </div> */}


{/* Architectural Consultancy */}
{/* Mandatory Service */}

<label className="dw-option mandatory">

  <input
    type="checkbox"
    checked
    disabled
  />

  <span className="dw-custom-radio"></span>

  <span className="dw-option-text">

    <strong>Architectural Design Services</strong>

    Complete architectural design support including planning,
    construction drawings, 3D visualizations, consultant coordination,
    and periodic site visits during construction.

  </span>

</label>


{/* Optional Service */}

<label className="dw-option">

  <input
    type="checkbox"
    checked={formData.architecture === "liaison"}
    onChange={(e) =>
      setFormData({
        ...formData,
        architecture: e.target.checked ? "liaison" : "design"
      })
    }
  />

  <span className="dw-custom-radio"></span>

  <span className="dw-option-text">

    <strong>Liaisoning & Authority Approvals</strong>

    Complete support for obtaining project permissions from municipal
    corporations and other local authorities.

  </span>

</label>


{/* Construction Services */}

<div className="dw-radio-block">

  <h6>Construction Services</h6>

  <label className="dw-option">

    <input
      type="radio"
      name="construction"
      checked={formData.construction === "grey"}
      onChange={() =>
        setFormData({ ...formData, construction: "grey" })
      }
    />

    <span className="dw-custom-radio"></span>

    <span className="dw-option-text">

      <strong>Grey Structure Only</strong>

      Construction of the core building structure including RCC framework,
      brickwork, and plaster.

    </span>

  </label>


  <label className="dw-option">

    <input
      type="radio"
      name="construction"
      checked={formData.construction === "complete"}
      onChange={() =>
        setFormData({ ...formData, construction: "complete" })
      }
    />

    <span className="dw-custom-radio"></span>

    <span className="dw-option-text">

      <strong>Complete Construction</strong>

      End-to-end construction from structural work to final finishing,
      ready for occupancy.

    </span>

  </label>


  <label className="dw-option">

    <input
      type="radio"
      name="construction"
      checked={formData.construction === "pmc"}
      onChange={() =>
        setFormData({ ...formData, construction: "pmc" })
      }
    />

    <span className="dw-custom-radio"></span>

    <span className="dw-option-text">

      <strong>Project Management Consultancy (PMC)</strong>

      End-to-end construction support to manage your project smoothly
      from planning to final execution.

    </span>

  </label>

</div>

                <div className="dw-btn-row">
                  <button className="dw-back-btn" onClick={handleBack}>
                    <span className="dw-arrow">&#x2039;</span> Back
                  </button>

                  <button
                    className={`dw-next-btn ${
                      !isStep3Valid() ? "disabled" : ""
                    }`}
                    disabled={!isStep3Valid()}
                    onClick={handleNext}
                  >
                    Next <span className="dw-arrow">&#x203A;</span>
                  </button>
                </div>
              </>
            )}

           {/* STEP 4 */}
{/* STEP 4 */}
{step === 3 && (
  <>
    <h4>Contact Information</h4>
    <p className="dw-subtext">
      Provide your contact details so we can send you the estimate.
    </p>

    {/* FULL NAME */}
    <div className="dw-field">
      <input
        type="text"
        placeholder=" "
        value={formData.fullName}
        onChange={(e) => {
          const value = e.target.value;
          if (/^[A-Za-z ]*$/.test(value)) {
            setFormData({ ...formData, fullName: value });
          }
        }}
        className={errors.fullName ? "error" : ""}
      />
      <label>Full Name *</label>
    </div>
    {errors.fullName && <p className="dw-error">{errors.fullName}</p>}

    {/* EMAIL */}
    <div className="dw-field">
      <input
        type="email"
        placeholder=" "
        value={formData.email}
        onChange={(e) =>
          setFormData({ ...formData, email: e.target.value })
        }
        className={errors.email ? "error" : ""}
      />
      <label>Email Address *</label>
    </div>
    {errors.email && <p className="dw-error">{errors.email}</p>}

    {/* PHONE */}
    <div className="dw-field">
      <input
        type="tel"
        placeholder=" "
        inputMode="numeric"
        pattern="[0-9]*"
        value={formData.phone}
        onChange={(e) => {
          const value = e.target.value;
          if (/^[0-9]*$/.test(value) && value.length <= 10) {
            setFormData({ ...formData, phone: value });
          }
        }}
        className={errors.phone ? "error" : ""}
      />
      <label>Phone Number *</label>
    </div>
    {errors.phone && <p className="dw-error">{errors.phone}</p>}

    <div className="dw-btn-row">
      <button className="dw-back-btn" onClick={handleBack}>
        <span className="dw-arrow">&#x2039;</span> Back
      </button>

      <button
        className="dw-submit-btn"
        onClick={() => {
          if (validateStep4()) {
            handleSubmit();
          }
        }}
      >
        Get My Detailed Estimate{" "}
        <span className="dw-arrow">&#x203A;</span>
      </button>
    </div>
  </>
)}
          </div>
        </div>
      </div>

    
   
  );
}

export default CalculateCost;
